export function tryParseJson<T extends any>(text: string): T | undefined {
  try {
    return JSON.parse(text);
  } catch {
    return undefined;
  }
}
